import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDocRelatedRecords, getTransactionRevArrangement, getTransactionRevArrangRevenueElement } from "../../../api/transaction-type";
import {
  salesOrderTransactionsTable,
  invoicePaymentsTable,
  invoiceSupportCasesTable,
  salesOrderRelatedRecordTable,
  salesOrderRelatedRecordTransformationTable,
  invoicePayment,
  invoiceRevenueArrangement,
  invoiceTransformationTable,
  invoiceRelatedExpenseReportTable,
  invoiceRelatedExpenseReportAttachmentsTable,
  CashSaleTransformationTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { makeStyles } from "@mui/styles";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import AgGridNonPaginatedTable from "../../../components/AgGridNonPaginatedTable";
import PrintViewDialog from "../../../components/Printdialog";
import { set } from "date-fns";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function InvoiceRelatedRecords({ tabIndexP,rowData }) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [TableData, setTableData] = useState([]);
 const [open, setOpen] = useState(false);
  const [id, setId] = useState("");

  async function getTransactionRelatedRecordsData(limit = 10, offset = 0) {
    setLoading(true);
    setId(params.docNo);
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setTableData(data?.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

    async function getTransactionRevArrangRevenueData(limit, offset) {
      try {
        const { data } = await getTransactionRevArrangement(user.token, {
          id: params.docNo,
          limit,
          offset,
        });
        return { rows: data.data.data, total: data.data.total, error: false };
      } catch (error) {
        console.log(error);
        snackbar.showError("Error In Loading Data.");
        return { error: true };
      } finally {
        // setLoading(false);
      }
    }
  
    const handleClose = () => {
      setOpen(false);
    };
  return (
    <>
      <Box p={1}>
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
          // className="tabs-sub-bkg"
        >
          <Tab label="Payments" />
          <Tab label="Revenue Arrangements" />
          <Tab label="Transformations" />
          <Tab label="Expense Reports" />
          <Tab label="Expense Reports Attachments" />
          <Tab label="Vendor Bills" />
          <Tab label="Vendor Bills Attachments" />
          <Tab label="Journals Of Billable Invoice" />
        </Tabs>
        <TabPanel value={tabIndexRelatedRecord} index={0}>
          <Box className="viewDetailsBox" display="flex">
            <Button
              className="backBtn"
              style={{ margin: "2px" }}
              onClick={() => {setOpen(true)}}
            >
              Print
            </Button>
          </Box>
          <AgGridNonPaginatedTable
            getTableRows={getTransactionRelatedRecordsData}
            columns={invoicePayment}
            refreshCounter={0}
            perPage={5}
          />
          <div className="m-b-10" style={{ border: "1px solid" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3} md={3} className="m-b-10">
                <p className="tFormlabel" style={{ textAlign: "end" }}>
                  Total
                </p>
              </Grid>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
               
              </Grid>
              <Grid item xs={12} sm={5} md={5} className="m-b-10">
                <p className="tFormName" style={{ textAlign: "end" }}>{TableData?.totalsum}</p>
              </Grid>
            </Grid>
          </div>
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <AgGridPaginatedTable
            getTableRows={getTransactionRevArrangRevenueData}
            columns={invoiceRevenueArrangement}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceTransformationTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceRelatedExpenseReportTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={4}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceRelatedExpenseReportAttachmentsTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={5}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceRelatedExpenseReportTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={6}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceRelatedExpenseReportAttachmentsTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={7}>
          <Box py={1} mt={1}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">DATE</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="list">Default</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="list">FROM</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">TO</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="list">Default</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={CashSaleTransformationTable}
            refreshCounter={0}
          />
        </TabPanel>
        <PrintViewDialog open={open} id={id} rowData={rowData}  handleClose={handleClose}/>
      </Box>
    </>
  );
}
